/* eslint-disable react/react-in-jsx-scope */
import ReactBreadcrumb from "@/components/breadcrumb/Breadcrumb";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import { useFetchDataV2 } from "@/hooks/useFetchDataV2";
import ProjectListCard from "@/project-owner/components/ProjectListCard";
import { Project } from "@/types/pp";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

const ProjectOwner = () => {
  const [projectsData, setProjectsData] = useState<Project[]>([]);
  const { programId, firstname } = useParams();
  const actions = "";
  const navigate = useNavigate();
  const { data, loading } = useFetchDataV2<Project[]>(
    `${import.meta.env.VITE_API_ENDPOINT}/financer/projects`,
    `projects`,
    1000 * 60 * 60
  );
  const { t } = useTranslation("dashboard", {
    keyPrefix: "program",
  });
  useEffect(() => {
    if (data && data.length) {
      const filteredData = data.filter(
        (item) => item.program.id === parseInt(programId)
      );
      if (filteredData.length > 0) {
        setProjectsData(filteredData);
      } else {
        navigate("../");
      }
    }
  }, [data, programId]);

  return (
    <div>
      <div className="mb-5">
        {!loading && projectsData.length > 0 && (
          <ReactBreadcrumb
            items={[
              {
                href: `/${firstname}`,
                name: t("Tableau de bord"),
              },
              {
                href: `/${firstname}/pp/${projectsData[0]?.program?.carrier?.id}`,
                name: projectsData[0]?.program?.carrier?.fullname,
              },
              {
                href: ``,
                name: projectsData[0]?.program?.name,
              },
            ]}
            isTruncated={false}
          />
        )}
      </div>
      {projectsData.length > 0 && (
        <div style={{ maxWidth: "calc(100% - 270px)" }}>
          <h1 className="text-3xl font-bold mb-5">
            {projectsData[0]?.program?.name}
          </h1>
          <p>{projectsData[0]?.program?.description}</p>
        </div>
      )}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <ProjectListCard projects={projectsData} actions={actions} />
      )}
    </div>
  );
};
export default ProjectOwner;
